import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { MainUiModule } from './main-ui/main-ui.module';
import { SharedApiModule } from './shared-api/shared-api-module';
import { SharedUiModule } from './shared-ui/shared-ui-module';

import { AppComponent } from './app.component';

import { StartComponent } from './start/start.component';
import { HeaderComponent } from './header/header.component';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';

import { MenubarModule } from 'primeng/menubar';
import { ConfirmationService, MessageService, TreeDragDropService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MainUiModule,
    SharedApiModule,
    SharedUiModule,
    ConfirmDialogModule,
    DropdownModule,
    MenubarModule,
  ],
  declarations: [
    AppComponent,
    StartComponent,
    HeaderComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ConfirmationService,
    MessageService,
    TreeDragDropService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
